
const ServicesSection = () => {
  const services = [
    {
      id: 1,
      title: 'Banyo Tadilatı',
      description: 'Modern ve fonksiyonel banyo tasarımları',
      icon: 'ri-drop-line',
      link: '/hizmetler',
      image: 'https://public.readdy.ai/ai/img_res/a85f3d6e3c9821808bc8c65a95f58196.jpg',
    },
    {
      id: 2,
      title: 'Mutfak Tadilatı',
      description: 'Hayalinizdeki mutfağı gerçeğe dönüştürüyoruz',
      icon: 'ri-restaurant-line',
      link: '/hizmetler',
      image: 'https://readdy.ai/api/search-image?query=modern%20kitchen%20renovation%20elegant%20white%20cabinets%20wooden%20countertop%20sophisticated%20design%20built-in%20appliances%20minimalist%20style%20warm%20lighting%20functional%20layout%20high%20quality%20materials%20contemporary%20interior&width=800&height=600&seq=service-kitchen-001&orientation=landscape',
    },
    {
      id: 3,
      title: 'Anahtar Teslim Tadilat',
      description: 'Baştan sona komple tadilat çözümleri',
      icon: 'ri-key-line',
      link: '/hizmetler',
      image: 'https://readdy.ai/api/search-image?query=complete%20apartment%20renovation%20before%20and%20after%20modern%20interior%20transformation%20elegant%20living%20space%20with%20wooden%20elements%20light%20beige%20tones%20professional%20construction%20work%20high%20quality%20finished%20project%20sophisticated%20design&width=800&height=600&seq=service-turnkey-001&orientation=landscape',
    },
    {
      id: 4,
      title: 'Komple Daire Tadilatı',
      description: 'Evinizi yeniden tasarlıyoruz',
      icon: 'ri-home-4-line',
      link: '/hizmetler',
      image: 'https://readdy.ai/api/search-image?query=complete%20home%20renovation%20modern%20apartment%20interior%20elegant%20living%20room%20with%20wooden%20floors%20light%20beige%20walls%20sophisticated%20furniture%20minimalist%20design%20natural%20lighting%20high%20quality%20finish%20contemporary%20style&width=800&height=600&seq=service-complete-apt-001&orientation=landscape',
    },
    {
      id: 5,
      title: 'Cafe Tadilatı',
      description: 'İşletmeniz için özel tasarım ve uygulama',
      icon: 'ri-store-2-line',
      link: '/hizmetler',
      image: 'https://readdy.ai/api/search-image?query=modern%20cafe%20interior%20renovation%20elegant%20coffee%20shop%20design%20wooden%20furniture%20warm%20lighting%20cozy%20atmosphere%20sophisticated%20decor%20minimalist%20style%20professional%20commercial%20space%20high%20quality%20finish%20contemporary%20ambiance&width=800&height=600&seq=service-cafe-001&orientation=landscape',
    },
    {
      id: 6,
      title: 'Mimari Tasarım',
      description: 'Profesyonel mimari proje ve tasarım hizmetleri',
      icon: 'ri-pencil-ruler-2-line',
      link: '/hizmetler',
      image: 'https://readdy.ai/api/search-image?query=architectural%20design%20blueprints%203D%20visualization%20modern%20interior%20planning%20professional%20workspace%20with%20wooden%20desk%20elegant%20minimalist%20style%20technical%20drawings%20computer%20screen%20showing%20floor%20plans%20warm%20lighting%20sophisticated%20office%20environment&width=800&height=600&seq=service-arch-design-001&orientation=landscape',
    },
    {
      id: 7,
      title: 'Dış Cephe Uygulamaları',
      description: 'Binanızın dış görünümünü yeniliyoruz',
      icon: 'ri-building-line',
      link: '/hizmetler',
      image: 'https://readdy.ai/api/search-image?query=modern%20building%20facade%20renovation%20elegant%20exterior%20design%20contemporary%20architecture%20wooden%20cladding%20elements%20sophisticated%20finish%20professional%20construction%20work%20high%20quality%20materials%20clean%20lines%20urban%20style&width=800&height=600&seq=service-facade-001&orientation=landscape',
    },
    {
      id: 8,
      title: 'Çatı ve İzolasyon',
      description: 'Çatı onarımı ve ısı-su yalıtım sistemleri',
      icon: 'ri-shield-check-line',
      link: '/hizmetler',
      image: 'https://readdy.ai/api/search-image?query=roof%20renovation%20construction%20work%20professional%20roofing%20installation%20modern%20building%20exterior%20sophisticated%20craftsmanship%20high%20quality%20materials%20waterproofing%20insulation%20work%20clean%20organized%20construction%20site&width=800&height=600&seq=service-roof-001&orientation=landscape',
    },
  ];

  return (
    <section id="hizmetler" className="py-24 bg-cream">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-beige/20 rounded-full mb-6">
            <span className="text-wood-dark font-medium">Hizmetlerimiz</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-wood-dark mb-4">
            Profesyonel Tadilat Hizmetleri
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            İzmir'de ev ve işyeri tadilat projeleriniz için kapsamlı çözümler sunuyoruz
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {services.map((service) => (
            <a
              key={service.id}
              href={service.link}
              className="group bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              {/* Kapak Fotoğrafı */}
              <div className="relative h-40 md:h-44 w-full overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-3 left-3">
                  <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-white/90 backdrop-blur-sm rounded-lg">
                    <i className={`${service.icon} text-lg md:text-xl text-wood-dark`}></i>
                  </div>
                </div>
              </div>
              
              {/* İçerik */}
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-bold text-wood-dark mb-1 group-hover:text-wood transition-colors duration-300 leading-tight">
                  {service.title}
                </h3>
                
                <p className="text-xs md:text-sm text-gray-600 leading-relaxed mb-3">
                  {service.description}
                </p>

                <div className="flex items-center text-wood-dark group-hover:text-wood transition-colors duration-300">
                  <span className="text-xs md:text-sm font-medium">Detaylı Bilgi</span>
                  <i className="ri-arrow-right-line ml-2 transform group-hover:translate-x-1 transition-transform duration-300 text-sm"></i>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="/hizmetler"
            className="inline-flex items-center space-x-2 px-8 py-4 bg-wood-dark hover:bg-wood text-white rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <span>Tüm Hizmetleri Görüntüle</span>
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
